import ApprovedActivitiesList from "../../../Components/Organisms/ApprovedActivity/List";

const ApprovedActivitiesTemplate = (props) => {
  const {
    t,
    activitesList,
    setActivitiesList,
    count,
    getActivities,
    requestedActivitiesPrivilages,
    setOpenLoader,
    filterObj,
    setFilterObj,
    profileData
  } = props;

  return (
    <ApprovedActivitiesList
      activitesList={activitesList}
      setActivitiesList={setActivitiesList}
      count={count}
      getActivities={getActivities}
      activitiesPrivilages={requestedActivitiesPrivilages}
      setOpenLoader={setOpenLoader}
      filterObj={filterObj}
      setFilterObj={setFilterObj}
      profileData={profileData}
    />
  );
};

export default ApprovedActivitiesTemplate;
